import React from 'react'
import Link from 'gatsby-link'

import styles from './Popup.module.css'
import FieldDefinitions from '../data/FieldDefinitions'

import Betr from './Betreuung'

class PopupBetr extends React.Component {
  constructor(props) {
    super(props)
  }

  intToTime = number => {
    const str = `${number}`
    return str.length > 3
      ? str[0] + str[1] + ':' + str[2] + str[3]
      : str[0] + ':' + str[1] + str[2]
  }

  render() {
    return (
      <div className={styles.text}>
        Website:{' '}
        <a
          href={this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde}
        >
          {this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde}
        </a>
        <br />
        Telefonnummer Gemeinde:{' '}
        <a
          href={
            'tel:' +
            this.props.data.zusatzGemeinden.edges[0].node.Telefon_Gemeinde
          }
        >
          {this.props.data.zusatzGemeinden.edges[0].node.Telefon_Gemeinde}
        </a>
        <hr />
        {this.props.data.betriebe &&
          this.props.data.betriebe.edges.map((edge, step) => {
            const zusatzInfo = this.props.data.zusatzBetriebe.edges.find(
              e => e.node.Kennzahl == edge.node['Kennzahl']
            )

            return (
              <Betr
                key={step}
                data={this.props.data}
                edge={edge}
                step={step}
                intToTime={this.intToTime}
                zusatzInfo={zusatzInfo && zusatzInfo.node}
              />
            )
          })}
        {!this.props.data.gemeinde.oeffTag_0_3J && (
          <div className={styles.fillerText}>
            Kein Betreuungsangebot für unter-3-jährige Kinder in der Gemeinde
            vorhanden.
            {this.props.data.kooperationen.edges.find(
              k => this.props.data.gemeinde.iso === k.node.iso
            ).node.koop_u3J_GEM ? (
              <div>
                <br />
                In diesem Bereich wird mit der Gemeinde{' '}
                <a
                  href="#"
                  onClick={() =>
                    this.props.openPopup(
                      this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_u3J_GEM
                    )}
                >
                  {
                    this.props.data.alleGemeinden.edges.find(
                      k =>
                        this.props.data.kooperationen.edges.find(
                          k => this.props.data.gemeinde.iso === k.node.iso
                        ).node.koop_u3J_GEM === k.node.iso
                    ).node.name
                  }
                </a>{' '}
                kooperiert.
              </div>
            ) : null}
            <hr />
          </div>
        )}
        {!this.props.data.gemeinde.oeffTag_3_6J && (
          <div className={styles.fillerText}>
            Kein Betreuungsangebot für 3-6-jährige Kinder in der Gemeinde
            vorhanden.
            {this.props.data.kooperationen.edges.find(
              k => this.props.data.gemeinde.iso === k.node.iso
            ).node.koop_3_6J_GEM ? (
              <div>
                <br />
                In diesem Bereich wird mit der Gemeinde{' '}
                <a
                  href="#"
                  onClick={() =>
                    this.props.openPopup(
                      this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_3_6J_GEM
                    )}
                >
                  {
                    this.props.data.alleGemeinden.edges.find(
                      k =>
                        this.props.data.kooperationen.edges.find(
                          k => this.props.data.gemeinde.iso === k.node.iso
                        ).node.koop_3_6J_GEM === k.node.iso
                    ).node.name
                  }
                </a>{' '}
                kooperiert.
              </div>
            ) : null}
            <hr />
          </div>
        )}
        {this.props.data.gemeinde.VS_Ki_NMB === 'ja' ? (
          <div className={styles.fillerText}>
            Nachmittagsbetreuung für Volksschulkinder ist in der Volksschule
            vorhanden.<hr />
          </div>
        ) : (
          <div className={styles.fillerText}>
            Kein Betreuungsangebot für Volksschulkinder in der Gemeinde
            vorhanden.
            {this.props.data.kooperationen.edges.find(
              k => this.props.data.gemeinde.iso === k.node.iso
            ).node.koop_NMB_GEM ? (
              <div>
                <br />
                In diesem Bereich wird mit der Gemeinde{' '}
                <a
                  href="#"
                  onClick={() =>
                    this.props.openPopup(
                      this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_NMB_GEM
                    )}
                >
                  {
                    this.props.data.alleGemeinden.edges.find(
                      k =>
                        this.props.data.kooperationen.edges.find(
                          k => this.props.data.gemeinde.iso === k.node.iso
                        ).node.koop_NMB_GEM === k.node.iso
                    ).node.name
                  }
                </a>{' '}
                kooperiert.
              </div>
            ) : null}
            <hr />
          </div>
        )}
        {this.props.data.zusatzGemeinden.edges[0].node.Zusatzinfo && (
          <div>
            <span className={styles.fillerText}>Zusätzliche Information:</span>
            {` ${this.props.data.zusatzGemeinden.edges[0].node.Zusatzinfo}`}
            <hr />
          </div>
        )}
        <a
          style={{ cursor: 'pointer', fontWeight: 'bold' }}
          onClick={() => this.props.switchMenu(0)}
        >
          &gt; &gt; &gt; zum Indikator „Vereinbarkeit von Beruf und Familie“
        </a>
        <br />
        Quelle: Amt der Burgenländischen Landesregierung,
        Kindertagesheimstatistik 2025/2026
      </div>
    )
  }
}

export default PopupBetr



// WEBPACK FOOTER //
// ./src/components/PopupEinrichtung.js